import { useEffect, useState } from "react"
import Template from "../components/Template"
import DocumentCard from "../components/DocumentCard"
import {Container, Button, Alert, Form} from 'react-bootstrap'
import {LinkContainer} from 'react-router-bootstrap'
import {useSelector, useDispatch} from 'react-redux'
import {listAllDocuments} from '../actions/documentActions'
import Loader from '../components/Loader'
import Pagination from "../components/Pagination"
import {useHistory, useLocation} from 'react-router-dom'

const Documents = () => {
  const {user} = useSelector(state => state.login)
  const {loading, error, documents,count,page} = useSelector(state => state.documents)
  const dispatch = useDispatch()
  const [documentTitle, setDocumentTitle] = useState('')
  const location = useLocation()
  const history = useHistory()

  const searchUrl = (key, value) => {
      const search = new URLSearchParams(location.search)
      if(search.has(key)) search.delete(key)
      if(key !== 'page') search.delete('page')
      search.append(key, value)
      return search.toString()
  }

  const documentsSearchHandler = e => {
    e.preventDefault()
    history.push(`${location.pathname}?keyword=${documentTitle}`)
  }

  const resetSearchHandler = _ => {
    setDocumentTitle('')
    history.push(`${location.pathname}`)
  }

  useEffect(() => {
    dispatch(listAllDocuments(location.search))
  },[dispatch, location])

  return (
      <Template>
        <h2 className='main__title'>الوثائق</h2>
        <Container>
        <div className="documents__header">
          {(user.data.isAdmin || user.data.isCoAdmin) && <LinkContainer to='/documents/new'>
            <Button variant='light'>إضافة وثيقة جديدة</Button>
          </LinkContainer>}
          <Button onClick={resetSearchHandler} variant='info'>إظهار جميع الوثائق</Button>
          <Form className='navigation__search users__search' onSubmit={documentsSearchHandler}>
            <Form.Control
            type="text"
            placeholder="ابحث بعنوان الوثيقة"
            className="mr-sm-2"
            value={documentTitle}
            onChange={({target:{value}}) => setDocumentTitle(value)} />
            <Button variant="outline-success">بحث</Button>
          </Form>
        </div>
        {loading ? <Loader/>
        :error ? <Alert variant='warning'>{error}</Alert>
        :<><div className='documents'>
            {documents && documents.map(document => (
              <DocumentCard key={document._id} info={document}/>
            ))}
          </div>
           {documents && <Pagination
            count={count}
            page={page}
            searchHandler={searchUrl}
            />}
            </>}
        </Container>
      </Template>
    )
}

export default Documents
